import React, { useState } from 'react';
import { Box, Button, Typography, TextField, InputAdornment, IconButton } from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useNavigate } from 'react-router-dom';
import loginbg from '../Assests/loginbg.png';

import { useAuth } from '../Context/AuthContext';
import { hrLoginUser } from '../Apis/LoginApis';
const LoginPage = () => {
    const [userId, setUserId] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleLogin = async () => {
        if (!userId || !password) {
            setError('Please enter both User ID and Password');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const data = {
                email: userId,
                password,
                fcmTokenWeb: "web_token_here",
                fcmTokenMobile: "mobile_token_here"
            };
            const response = await hrLoginUser(data);

            if (response && response.data && response.data.token) {
                const userObj = response.data.user;
                if (userObj) {
                    localStorage.setItem('iti_user_name', `${userObj.firstName} ${userObj.lastName}`);
                }
                const sessionData = {
                    ...response.data,
                    iti_active_token: response.data.token
                };
                delete sessionData.token; 
                login(sessionData);
                navigate('/');
            } else {
                setError('Login failed: Invalid server response');
            }
        } catch (err) {
            console.error("Login failed", err);
            setError(err.response?.data?.message || 'Login failed. Please check your credentials.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box
            sx={{
                width: '100vw',
                height: '100vh',
                backgroundImage: `url(${loginbg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                position: 'relative',
                overflow: 'hidden',
                fontFamily: 'Space Grotesk, sans-serif'
            }}
        >


            {/* Login Card */}
            <Box
                sx={{
                    position: 'relative',
                    zIndex: 2,
                    ml: 0,
                    mr: { xs: 0, md: '5%', lg: '8%' },
                    width: '100%',
                    maxWidth: '450px',
                }}
            >
                <Box
                    sx={{
                        bgcolor: '#87CEEB', // SkyBlue
                        borderRadius: 4,
                        p: { xs: 4, md: 6 },
                        boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                        textAlign: 'center',
                    }}
                >
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 700,
                            mb: 4,
                            color: '#1A1A1A',
                            fontFamily: 'Space Grotesk, sans-serif'
                        }}
                    >
                        SkillTech Industry Connect
                    </Typography>

                    <Box component="form" noValidate sx={{ width: '100%', textAlign: 'left' }}>
                        {error && (
                            <Typography color="error" variant="body2" sx={{ mb: 2, textAlign: 'center' }}>
                                {error}
                            </Typography>
                        )}

                        <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#333' }}>
                            <PersonOutlineIcon sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: '1.1rem' }} />
                            User ID
                        </Typography>
                        <TextField
                            fullWidth
                            placeholder="Enter Your Id"
                            variant="outlined"
                            value={userId}
                            onChange={(e) => setUserId(e.target.value)}
                            sx={{
                                mb: 3,
                                bgcolor: 'white',
                                borderRadius: 1,
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': { border: 'none' }, // Remove default border
                                    borderRadius: 1,
                                },
                                '& input': {
                                    py: 1.5,
                                    fontSize: '0.9rem',
                                }
                            }}
                        />

                        <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#333' }}>
                            <VpnKeyIcon sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: '1.1rem' }} />
                            Password
                        </Typography>
                        <TextField
                            fullWidth
                            placeholder="************"
                            type={showPassword ? 'text' : 'password'}
                            variant="outlined"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                mb: 4,
                                bgcolor: 'white',
                                borderRadius: 1,
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': { border: 'none' },
                                    borderRadius: 1,
                                },
                                '& input': {
                                    py: 1.5,
                                    fontSize: '0.9rem',
                                }
                            }}
                        />

                        <Button
                            fullWidth
                            onClick={handleLogin}
                            sx={{
                                bgcolor: '#FFB300', // Amber/Yellow
                                color: '#000',
                                fontWeight: 700,
                                py: 1.5,
                                borderRadius: 1,
                                textTransform: 'none',
                                fontSize: '1rem',
                                '&:hover': {
                                    bgcolor: '#FFA000',
                                },
                                boxShadow: 'none'
                            }}
                            disabled={loading}
                        >
                            {loading ? 'Logging in...' : 'Login'}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default LoginPage;
